<img
  id="logo"
  ngSrc="assets/img/ogi-logo.png"
  width="200"
  height="51"
  alt="OGI Logo"
  priority
/>
<div id="page">
  <div id="container">
    <h4>Two-Factor Authentication</h4>
    @if (!isRecoveryCodeMode()) {
      <div class="body1">
        Enter the 6-digit code from your authenticator app.
      </div>
      <form [formGroup]="challengeForm">
        <div class="digit-inputs" (paste)="onPaste($event)">
          <input
            #digitInput
            type="text"
            maxlength="1"
            formControlName="digit0"
            aria-label="Digit 1 of 6"
            inputmode="numeric"
            autocomplete="off"
            autofocus
            (focus)="onDigitFocus($event)"
            (input)="onDigitInput(0, $event)"
            (keydown)="onDigitKeydown($event, 0)"
          />
          <input
            #digitInput
            type="text"
            maxlength="1"
            formControlName="digit1"
            aria-label="Digit 2 of 6"
            inputmode="numeric"
            autocomplete="off"
            (focus)="onDigitFocus($event)"
            (input)="onDigitInput(1, $event)"
            (keydown)="onDigitKeydown($event, 1)"
          />
          <input
            #digitInput
            type="text"
            maxlength="1"
            formControlName="digit2"
            aria-label="Digit 3 of 6"
            inputmode="numeric"
            autocomplete="off"
            (focus)="onDigitFocus($event)"
            (input)="onDigitInput(2, $event)"
            (keydown)="onDigitKeydown($event, 2)"
          />
          <input
            #digitInput
            type="text"
            maxlength="1"
            formControlName="digit3"
            aria-label="Digit 4 of 6"
            inputmode="numeric"
            autocomplete="off"
            (focus)="onDigitFocus($event)"
            (input)="onDigitInput(3, $event)"
            (keydown)="onDigitKeydown($event, 3)"
          />
          <input
            #digitInput
            type="text"
            maxlength="1"
            formControlName="digit4"
            aria-label="Digit 5 of 6"
            inputmode="numeric"
            autocomplete="off"
            (focus)="onDigitFocus($event)"
            (input)="onDigitInput(4, $event)"
            (keydown)="onDigitKeydown($event, 4)"
          />
          <input
            #digitInput
            type="text"
            maxlength="1"
            formControlName="digit5"
            aria-label="Digit 6 of 6"
            inputmode="numeric"
            autocomplete="off"
            (focus)="onDigitFocus($event)"
            (input)="onDigitInput(5, $event)"
            (keydown)="onDigitKeydown($event, 5)"
          />
        </div>
        <app-checkbox
          [checkbox]="rememberDevice"
          [parentForm]="challengeForm"
        ></app-checkbox>
      </form>
    } @else {
      <div class="body1">
        Enter one of the recovery codes you saved. Each recovery code works
        once.
      </div>
      <form [formGroup]="recoveryCodeForm">
        <app-mat-form-field
          (keydown.enter)="handleSubmit()"
          [field]="recoveryCodeField"
          [parentForm]="recoveryCodeForm"
        >
        </app-mat-form-field>
      </form>
    }
    @if (error()?.message) {
      <p class="error">{{ error().message }}</p>
    }
    <div class="button--container">
      <app-button
        buttonStyle="standard"
        label="Verify"
        buttonId="verify-btn"
        [isDisabled]="
          isRecoveryCodeMode()
            ? recoveryCodeForm.invalid
            : challengeForm.invalid
        "
        [isProcessing]="isProcessing()"
        (buttonClicked)="handleSubmit()"
      >
      </app-button>
    </div>
    @if (isRecoveryCodeMode()) {
      <button
        type="button"
        id="use-2fa-code-btn"
        class="link-btn"
        (click)="use2FACode()"
      >
        Use a 2FA code instead
      </button>
    } @else {
      <button
        type="button"
        id="use-recovery-code-btn"
        class="link-btn"
        (click)="useRecoveryCode()"
      >
        Use a recovery code instead
      </button>
    }
    <div class="body2">
      Can’t access either? Please contact your organisation's Super User to reset
      your Two-Factor Authentication
    </div>
  </div>
</div>
